import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import Sprint, { bc } from './Sprint'
import { getIdentityUserData, getIdentityOrganization } from 'store/entities/identity/selectors'

import UserAvatar from 'app/components/UserAvatar'

const mapStateToProps = state => {
  const identity = getIdentityUserData(state)
  const organization = getIdentityOrganization(state)
  return {
    userAvatar: (
      <UserAvatar
        avatar={identity.get('avatar')}
        userName={identity.get('firstName')}
        userLastName={identity.get('lastName')}
        userEmail={identity.get('email')}
        className={`${bc}__user-avatar`}
      />
    ),
    organizationAvatar: (
      <UserAvatar
        avatar={organization.get('logo')}
        userEmail={organization.get('name')}
        className={`${bc}__user-avatar`}
      />
    ),
  }
}
export default connect(mapStateToProps)(withTranslation('user')(Sprint))
